import { KeycloakContext } from "@/app/providers/KeycloakProvider"
import { useUserStore } from "@/stores/user"
import { useContext } from "react"

export const AccessDeniedFallbackMessage = () => {
    const { logout: keycloakLogout } = useContext(KeycloakContext)
    const storeLogout = useUserStore((store) => store.logout)

    const handleClick = async () => {
        storeLogout()
        await keycloakLogout()
    }

    return <p>Неизвестная роль. Доступ запрещён. <a href="" onClick={handleClick}>Выход</a></p>
}
